import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./main-navigation-subcategory.module.css";

function SubCategory({ title, submenu, show, onCategoryClick, onClose, fullRender }) {
    const hasLinks = submenu.links && submenu.links.length > 0;
    const hasTrendMenus = submenu.trend_menus && submenu.trend_menus.length > 0;

    function renderSubCategory(submenu, type) {
        return submenu[type].map((menu) => (
            <SubCategory
                key={menu.display_name}
                title={menu.display_name}
                submenu={menu}
                fullRender={true}
            />
        ));
    }

    return (
        <>
            <div
                className={clsx(styles.subCategoryContainer, {
                    [styles.show]: show,
                })}
            >
                <button type="button" className={styles.subcategoryTitle} onClick={onClose}>
                    {!fullRender && (
                        <SVGIcon
                            className={styles.menuItemBigChevron}
                            name="arrow-icon"
                            flip={true}
                        />
                    )}
                    {title}
                </button>

                {hasLinks &&
                    submenu.links.map((link) => (
                        <a
                            key={link.url}
                            className={clsx(styles.menuItem, {
                                [styles.saleLink]: link.is_sale,
                            })}
                            href={link.url}
                        >
                            {link.is_sale && (
                                <SVGIcon
                                    className={clsx(styles.saleTag, styles.saleLink)}
                                    name="tag"
                                />
                            )}
                            {link.text}
                        </a>
                    ))}

                {hasTrendMenus &&
                    (submenu.trend_menus.length === 1 ? (
                        <>
                            <span
                                className={clsx(styles.menuItem, styles.menuItemBold)}
                                style={{ borderBottom: "none" }}
                            >
                                {submenu.trend_menus[0].display_name}
                            </span>

                            {submenu.trend_menus[0].links.map((link) => (
                                <a
                                    key={link.text}
                                    href={link.url}
                                    className={clsx(styles.menuItem, styles.linkItem)}
                                >
                                    {link.text}
                                </a>
                            ))}
                        </>
                    ) : (
                        <>
                            {submenu.trend_menus.map((trendMenu, index) => (
                                <button
                                    key={`${submenu.trend_heading}-${index}`}
                                    className={styles.menuItem}
                                    type="button"
                                    onClick={() => {
                                        onCategoryClick(trendMenu);
                                    }}
                                >
                                    {trendMenu.display_name}

                                    {!fullRender && (
                                        <SVGIcon
                                            className={styles.menuItemChevron}
                                            name="arrow-icon"
                                        />
                                    )}
                                </button>
                            ))}
                        </>
                    ))}
            </div>

            {fullRender && hasTrendMenus && renderSubCategory(submenu, "trend_menus")}
        </>
    );
}

SubCategory.propTypes = {
    title: PropTypes.string,
    submenu: PropTypes.object,
    isOpen: PropTypes.bool,
    onCategoryClick: PropTypes.func,
    onClose: PropTypes.func,
    show: PropTypes.bool,
    fullRender: PropTypes.bool,
};

export default SubCategory;
